/**
 * 构建emmet 类似xpath
 */
export const buildEmmet = (target: HTMLElement | null) => {
  let emmetString = '';
  if (!target) {
    return emmetString;
  }

  emmetString += target.tagName.toLowerCase();

  if (target.id) {
    emmetString += '#' + target.id;
  }

  const className = target.getAttribute('class');
  if (className) {
    emmetString += '.' + className.split(' ').join('.');
  }

  const text = target.textContent?.trim();
  if (text) {
    emmetString += `:contains("${text}")`;
  }

  return emmetString;
};

/**
 * 判断并获取有效的父元素，跳过SVG相关标签。
 */
export const getParentElement = (target: HTMLElement | null): HTMLElement | null => {
  if (!target) return null;
  const svgTags = ['svg', 'path', 'rect', 'circle', 'ellipse', 'line', 'polyline', 'polygon', 'g'];
  if (svgTags.includes(target.tagName?.toLowerCase?.() || '')) {
    return getParentElement(target.parentElement);
  }
  return target;
};
